import { render, staticRenderFns } from "./StudentsWithProgress.vue?vue&type=template&id=af1595fc"
import script from "./StudentsWithProgress.vue?vue&type=script&lang=js"
export * from "./StudentsWithProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports